













import { defineComponent, getCurrentInstance } from '@vue/composition-api';
import { useStampStore } from '@/store/stamp';
import { storeToRefs } from 'pinia';
import SvgIcon from '../common/svg-icon.vue';
import NgoStampGoal from '@/components/ngo-stamp-module/goal.vue';
import NgoStampNgo from '@/components/ngo-stamp-module/ngo.vue';
import { CONF, getMultiLangAttr } from '@/business/act-config';

export default defineComponent({
  name: 'NgoStampModule',
  components: { SvgIcon, NgoStampGoal, NgoStampNgo },
  setup() {
    const stampStore = useStampStore();
    const { userStampInfo } = storeToRefs(stampStore);

    // @ts-ignore
    const isDailyActivity = getCurrentInstance()?.proxy.$ActBaseConf.isDailyActivity;
    return {
      userStampInfo,
      isDailyActivity,
      title: getMultiLangAttr(CONF, 'project_title'),
    };
  },
});
